module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "140px",
      "height": "140px",
      "margin": "24px 24px 24px 24px",
      "display": "inline-block",
      "float": "left",
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: (_vm.avtStyle)
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "calc(100% - 188px)",
      "height": "100%",
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-appmain",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ?
    _vm.config.data.appName : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-app-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('psp_app_id')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appId : '') + "\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_appName')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.fileName : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_sysType')) + "：")]), _vm._v(" "), (_vm.app_detail.sysType == '0') ? _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v("RTOS")]) : _vm._e(), _vm._v(" "), (_vm.app_detail.sysType == '1') ? _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v("Linux")]) : _vm._e(), _vm._v(" "), (_vm.app_detail.sysType == '2') ? _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v("LiteOS")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('psp_app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.appVersion : ''))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_introl')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.memo : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-apptt"
  }, [_vm._v(_vm._s(_vm.$t('app_ulTime')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-appmain"
  }, [_vm._v(_vm._s(_vm.app_detail ? _vm.app_detail.createTime : ''))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "60px",
      "display": "-webkit-flex"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_appUpList')) + " ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_terminal'),
      "icon": "search",
      "on-icon-click": _vm.getAppList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getAppList($event)
      }
    },
    model: {
      value: (_vm.terminalNo),
      callback: function($$v) {
        _vm.terminalNo = $$v
      },
      expression: "terminalNo"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_terminal')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "status",
      "label": _vm.$t('app_status'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('span', [_vm._v(_vm._s(_vm.$t('app_success')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', [_vm._v(_vm._s(_vm.$t('mao_global.tip.fail')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.dateFormat,
      "prop": "updateTime",
      "label": _vm.$t('app_ulTime')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.row,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f31ec0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pspDetail.vue
// module id = 1042
// module chunks = 0